import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44aa542f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-[var(--primary-color)] px-10 py-[60px]" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex flex-col gap-y-5 mb-[64px] px-[53px] s:px-12" }
const _hoisted_4 = { class: "flex flex-wrap justify-center s:justify-start s:px-12 gap-y-9 s:gap-x-[130px] mb-[64px]" }
const _hoisted_5 = { class: "flex flex-col w-[204px]" }
const _hoisted_6 = { for: "name" }
const _hoisted_7 = { class: "flex flex-col w-[213px]" }
const _hoisted_8 = { for: "email" }
const _hoisted_9 = { class: "flex flex-col w-[204px]" }
const _hoisted_10 = { for: "phone" }
const _hoisted_11 = { class: "flex flex-col w-[213px]" }
const _hoisted_12 = { for: "text" }
const _hoisted_13 = { class: "flex flex-col m:flex-row gap-y-16 gap-x-9" }
const _hoisted_14 = { class: "grid grid-cols-[24px_auto] s:grid-cols-[40px_auto] gap-x-6" }
const _hoisted_15 = { class: "flex justify-center" }
const _hoisted_16 = {
  key: 1,
  class: "flex flex-col items-center justify-center gap-y-5 h-[862px] l:h-[480px]"
}

import { useWindowSize } from '@vueuse/core';
import { vMaska } from 'maska';
import { useI18n } from 'vue-i18n';
import { ref, computed } from 'vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseButton from '@/components/common/BaseButton.vue';
import type { ContactFormType } from '@/types/ContactFormType';


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const { width } = useWindowSize();
const { t } = useI18n();

const options = { mask: '+7 (###) ###-##-##' };

const form = ref<ContactFormType>({} as ContactFormType);
const agreement = ref<boolean>(false);
const sended = ref<boolean>(false);

const sendForm = () => {
    // ToDo: подключить PhPMailer.
    console.log('form:', form.value);
    sended.value = true;
};

const isDisabled = computed(() => {
    const phoneValid = /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(form.value.phone);
    return form.value.name !== '' && phoneValid && agreement.value;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!sended.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(BaseTypography, {
              text: _unref(t)('contacts.form.title'),
              type: _unref(width) > 768 ? 'subtitle' : 'title-m',
              color: "var(--base-white)",
              class: "max-w-[200px] s:max-w-max"
            }, null, 8, ["text", "type"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('contacts.form.subtitle'),
              type: _unref(width) > 768 ? 'special-body3' : 'body3-m',
              color: "var(--base-white)",
              class: "max-w-[200px] s:max-w-max"
            }, null, 8, ["text", "type"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('contacts.form.name'),
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--base-white)"
                }, null, 8, ["text", "type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                id: "name",
                name: "name",
                placeholder: "Иван",
                class: "edit bk",
                type: "text",
                required: ""
              }, null, 512), [
                [_vModelText, form.value.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('contacts.form.email'),
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--base-white)"
                }, null, 8, ["text", "type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.email) = $event)),
                type: "email",
                id: "email",
                placeholder: "ivan.ivanov@mail.ru",
                name: "email",
                class: "edit bk"
              }, null, 512), [
                [_vModelText, form.value.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('contacts.form.phone'),
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--base-white)"
                }, null, 8, ["text", "type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.phone) = $event)),
                placeholder: "+7(000)000-00-00",
                type: "tel",
                id: "phone",
                name: "phone",
                class: "edit bk",
                required: ""
              }, null, 512), [
                [_vModelText, form.value.phone],
                [_unref(vMaska), void 0, options]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('contacts.form.message'),
                  type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                  color: "var(--base-white)"
                }, null, 8, ["text", "type"])
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.text) = $event)),
                id: "text",
                name: "text",
                placeholder: "Ваше сообщение...",
                type: "text",
                class: "edit bk"
              }, null, 512), [
                [_vModelText, form.value.text]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: _normalizeClass(["h-6 w-6 s:h-10 s:w-10 bg-[var(--base-white)] rounded-full cursor-pointer", { 'border-[4px] border-[--secondary-color]': agreement.value }]),
                onClick: _cache[4] || (_cache[4] = () => (agreement.value = !agreement.value))
              }, null, 2),
              _createElementVNode("div", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('contacts.form.policy.first'),
                  type: _unref(width) > 768 ? 'caption' : 'caption-m',
                  color: "var(--base-white)",
                  tag: "span"
                }, null, 8, ["text", "type"]),
                _createVNode(_component_router_link, { to: "/consent" }, {
                  default: _withCtx(() => [
                    _createVNode(BaseTypography, {
                      text: _unref(t)('contacts.form.policy.second'),
                      type: _unref(width) > 768 ? 'caption' : 'caption-m',
                      class: "underline",
                      color: "var(--base-white)",
                      tag: "span"
                    }, null, 8, ["text", "type"])
                  ]),
                  _: 1
                }),
                _createVNode(BaseTypography, {
                  text: _unref(t)('contacts.form.policy.third'),
                  type: _unref(width) > 768 ? 'caption' : 'caption-m',
                  color: "var(--base-white)",
                  tag: "span"
                }, null, 8, ["text", "type"]),
                _createVNode(_component_router_link, { to: "/policy" }, {
                  default: _withCtx(() => [
                    _createVNode(BaseTypography, {
                      text: _unref(t)('contacts.form.policy.fourth'),
                      type: _unref(width) > 768 ? 'caption' : 'caption-m',
                      class: "underline",
                      color: "var(--base-white)",
                      tag: "span"
                    }, null, 8, ["text", "type"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(BaseButton, {
                text: _unref(t)('contacts.form.send'),
                type: _unref(width) > 768 ? 'subtitle4' : 'subtitle4-m',
                color: !isDisabled.value ? 'var(--base-white)' : 'var(--primary-color)',
                ui: !isDisabled.value ? 'disabled' : 'white',
                "padding-x": "85",
                "padding-y": "18",
                disabled: !isDisabled.value,
                onClick: sendForm
              }, null, 8, ["text", "type", "color", "ui", "disabled"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(BaseTypography, {
            text: _unref(t)('contacts.form.thanks.first'),
            type: "subtitle2-m",
            color: "var(--base-white)"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('contacts.form.thanks.second'),
            type: "subtitle2-m",
            color: "var(--base-white)",
            class: "text-center"
          }, null, 8, ["text"])
        ]))
  ]))
}
}

})